export default {"src":"/_next/static/media/BundleIcon.e323bd8c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};